import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Spinner } from "@/components/ui/spinner/spinner";

const BankPaymentLoader: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <Card className="max-w-md w-full bg-white rounded-2xl shadow-lg">
        <CardContent className="p-8 text-center">
          <div className="text-3xl font-bold text-green-400 mb-6 tracking-wide">
            Bank Payment
          </div>
          <div className="flex justify-center mb-4">
            <Spinner size="large" />
          </div>
          <div className="text-gray-700 text-lg">
            Please wait while bank API processes your payment...
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default BankPaymentLoader;
